<ng-container *ngIf="carrier._id">
  <ng-container *ngIf="carrier.logo as logo; else carrierLogo">
    <img
      class="logo img-fluid {{ size }}"
      [class.centered]="centered"
      [src]="logo"
    />
  </ng-container>
  <ng-template #carrierLogo>
    <img
      *ngIf="carriers | find: 'value' : carrier.code : 'logo' as logo"
      class="logo img-fluid {{ size }}"
      [class.centered]="centered"
      [src]="logo"
    />
  </ng-template>
  <ng-container *ngIf="showProvider">
    <div
      class="powered-by"
      *ngIf="
        providers | find: 'value' : carrier.provider : 'logo' as providerLogo
      "
    >
      <small>Powered by</small>
      <img class="provider img-fluid" [src]="providerLogo" />
    </div>
  </ng-container>
  <ng-container *ngIf="showName">
    <h6 class="text-muted text-center p-2">
      {{ carrier.customName }}
    </h6>
  </ng-container>
</ng-container>
